import { createContext, useContext } from 'react'

export type LogType =
  | 'mute'
  | 'unmute'
  | 'forward'
  | 'rewind'
  | 'seek'
  | 'fullscreen'
  | 'exitFullscreen'
  | 'play'
  | 'pause'
  | 'clickSpeedButton'
  | 'clickSubtitleButton'
  | 'clickQualityButton'
  | 'clickAutoPlayButton'
  | 'changeVolume'
  | 'changeSpeed'
  | 'changeSubtitle'
  | 'changeQuality'
  | 'clickFontSizeButton'
  | 'changeFontSize'
  | 'watch1Sec'
  | 'watch3Sec'
  | 'watch5Sec'
  | 'watch10Sec'
  | 'watch15Sec'
  | 'watch30Sec'
  | 'watchComplete'
  | 'toDetail'

type LoggerContextType = {
  [key in LogType]: (value?: string) => void
}

export const DefaultLogger: LoggerContextType = {
  mute: () => {},
  unmute: () => {},
  forward: () => {},
  rewind: () => {},
  seek: () => {},
  fullscreen: () => {},
  exitFullscreen: () => {},
  play: () => {},
  pause: () => {},
  clickSpeedButton: () => {},
  clickSubtitleButton: () => {},
  clickQualityButton: () => {},
  clickAutoPlayButton: () => {},
  changeVolume: () => {},
  changeSpeed: () => {},
  changeSubtitle: () => {},
  changeQuality: () => {},
  clickFontSizeButton: () => {},
  changeFontSize: () => {},
  watch1Sec: () => {},
  watch3Sec: () => {},
  watch5Sec: () => {},
  watch10Sec: () => {},
  watch15Sec: () => {},
  watch30Sec: () => {},
  watchComplete: () => {},
  toDetail: () => {},
}

export const LoggerContext = createContext<LoggerContextType>(DefaultLogger)

export const useLogger = () => {
  const context = useContext(LoggerContext)

  return context
}
